import * as api from './personal-contacts-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import * as action from './personal-contacts-action-creator';

export const loadPersonalContacts = (patientId) => (dispatch) =>
  api.getPersonalContacts(patientId)
    .then(
      (response) => dispatch(action.personalContactsLoaded(response.data)),
      () => {
        dispatch(MsgBarActions.showErrorMessage());
      });

export const submitAddContact = (contact, isEditMode, isInvited, fromAccountSettings) => (dispatch) =>
  api.putPersonalContact(contact).then(
    (response) => {
      dispatch(action.personalContactLoaded(response.data));
      dispatch(action.setPersonalContactId(response.data.contactId));
      if (!isEditMode) {
        if (!isInvited) {
          dispatch(MsgBarActions.showStickySuccessMessage('contactAddedSuccess'));
        }
      } else if (fromAccountSettings) {
        dispatch(MsgBarActions.showSuccessMessage('contactEditSuccess'));
      } else {
        dispatch(MsgBarActions.showStickySuccessMessage('contactEditSuccess'));
      }
    },
    () => {
      dispatch(MsgBarActions.showErrorMessage());
    }
  );

// // only use in unit-test
// export const setPersonalContact = (constId) => (dispatch) => {
//   dispatch(action.setPersonalContactId(constId));
// };

export const changePatientContactAccess = (contact, shouldEnableAccess) => (dispatch) =>
  api.postEnablePatientContactAccess(contact, shouldEnableAccess)
    .then(
      (response) => {
        if (shouldEnableAccess) {
          dispatch(action.enabledAccessState(response.data));
          dispatch(MsgBarActions.showSuccessMessage('contactAccessEnabled'));
        } else {
          dispatch(action.disabledAccessState(response.data));
          dispatch(MsgBarActions.showSuccessMessage('contactAccessDisabled'));
        }
      },
      () => {
        dispatch(MsgBarActions.showErrorMessage('failedChangeContactAccess'));
      }
    );

export const unlockPatientContactUserAccount = (contact) => (dispatch) =>
  api.postUnlockPatientContactUserAccount(contact)
    .then(
      () => {
        dispatch(action.unlockedAccount());
        dispatch(MsgBarActions.showSuccessMessage('contactUnlockAccount'));
      },
      () => {
        dispatch(MsgBarActions.showErrorMessage('failedContactUnlockAccount'));
      }
    );

export const resetPatientContactPassword = (contact) => (dispatch) =>
  api.resetContactPassword(contact)
    .then(
      () => {
        dispatch(action.resetContactPassword());
        dispatch(MsgBarActions.showSuccessMessage('contactPasswordReset', [contact.contactEmail]));
      },
      () => {
        dispatch(MsgBarActions.showErrorMessage('contactPasswordResetFailed'));
      }
    );
